import { LoggerScope } from '~/main/utils/logger';

export enum CFD_MESSAGES {
  SALE_UPDATED = 'SALE_UPDATED',
  SALE_COMPLETED = 'SALE_COMPLETED',
  TIP_FLOW_START = 'TIP_FLOW_START',
  TIP_CONFIRMED = 'TIP_CONFIRMED',
  HIDE_SALE = 'HIDE_SALE',
  SHOW_SALE = 'SHOW_SALE',
  CLOSE = 'CLOSE',
  COMPLETE_PAYMENT = 'COMPLETED_PAYMENT',
  CUSTOMER_START = 'CUSTOMER_START',
  CUSTOMER_SAVE = 'CUSTOMER_SAVE',
  CUSTOMER_CANCEL = 'CUSTOMER_CANCEL',
}

export enum PRINTER_MESSAGES {
  DEFAULT_PRINTERS = 'DEFAULT_PRINTERS',
  PRINT = 'PRINT',
  OPEN_CASH_DRAWER = 'OPEN_CASH_DRAWER',
  PRINT_COMPLETED = 'PRINT_COMPLETED',
  PRINT_ERROR = 'PRINT_ERROR',
}
export type Publish = (
  message: string,
  messageData?: string | Record<string, unknown> | undefined,
) => void;

export type Transport = LoggerScope.ABLY | LoggerScope.ABLY_CUSTOMER | LoggerScope.LOCAL_SERVER;
